export function Marca({ className = 'marca-app__logo' }: { className?: string }) {
  return (
    <svg className={className} viewBox="0 0 360 100" role="img" aria-label="interludio.">
      <text x="0" y="72" fontFamily="Archivo, system-ui, sans-serif" fontSize="80" letterSpacing="-3.2" fill="currentColor">
        <tspan fontWeight="300">interludio</tspan>
        <tspan fontWeight="700">.</tspan>
      </text>
    </svg>
  );
}
